export enum CalendarEventTimesChangedEventType {
    Drag = "drag",
    Drop = "drop",
    Resize = "resize"
  }
